interface Step {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

const STEPS: Step[] = [
  {
    step: "01",
    title: "Upload Your Photo",
    desc: "A clear, front-facing selfie. That's literally it. No special lighting or camera required.",
    icon: "📸",
  },
  {
    step: "02",
    title: "Add Your Message",
    desc: "Write a quick script, paste a TikTok URL to clone its format, or let AI generate one for you.",
    icon: "✍️",
  },
  {
    step: "03",
    title: "Download & Post",
    desc: "A professional talking-head video with perfect lip sync — ready in minutes, not hours.",
    icon: "🎬",
  },
];

const HowItWorks = () => (
  <section id="features" className="mx-auto mt-16 max-w-5xl px-4 sm:px-6">
    <div className="mb-8 text-center sm:mb-16">
      <span className="mb-4 inline-block rounded-full bg-card px-3 py-1 font-bold text-primary text-xs uppercase tracking-widest">
        How It Works
      </span>
      <h2 className="font-extrabold text-3xl text-zinc-900 tracking-tight sm:text-4xl">
        Three steps. First video in minutes.
      </h2>
      <p className="mt-2 text-[15px] text-zinc-500">
        No setup calls. No tutorials. Just results.
      </p>
    </div>

    <div className="grid gap-5 sm:grid-cols-3 sm:gap-8">
      {STEPS.map((f) => (
        <div
          key={f.step}
          className="group rounded-2xl border bg-white p-5 shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg sm:rounded-3xl sm:p-8"
        >
          <div className="mb-2 font-bold text-primary text-xs uppercase tracking-wider">
            Step {f.step}
          </div>
          <div className="mb-4 text-4xl">{f.icon}</div>
          <h3 className="mb-2 font-bold text-xl text-zinc-900">{f.title}</h3>
          <p className="text-sm text-zinc-500 leading-relaxed">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
